import { render, staticRenderFns } from "./teamPerformanceAdd.vue?vue&type=template&id=ab07d096&scoped=true&"
import script from "./teamPerformanceAdd.vue?vue&type=script&lang=js&"
export * from "./teamPerformanceAdd.vue?vue&type=script&lang=js&"
import style0 from "./teamPerformanceAdd.vue?vue&type=style&index=0&id=ab07d096&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab07d096",
  null
  
)

export default component.exports